import { makeStyles } from "@material-ui/core/styles";
import { iconRadioOn, iconRadio } from "assets/icons/importIcon";

const useStyles = makeStyles((theme: any) => {
  return {
    headerContent: {
      display: "flex",
      flexDirection: "row",
      marginTop: "20px",
      paddingLeft: "20px",
      paddingRight: "20px",
    },
    bodyModalList: {
      backgroundColor: "#FFF",
    },
    iconCloseIcon: {
      display: "flex",
      justifyContent: "flex-end",
      cursor: "pointer",
    },
    contentTitle: {
      flex: 1,
      display: "flex",
      textAlign: "center",
      font: `700 19px/25px "Montserrat"`,
      color: theme.custom.colors.primary,
      marginBottom: "20px",
    },
    typeTitle: {
      font: theme.custom.font.headingMontserrat3,
      paddingLeft: "20px",
      paddingRight: "20px",
      marginBottom: "20px",
    },
    submitContainer: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "20px",
    },
    submitBtn: {
      display: "flex",
      width: "150px",
      height: "45px",
      alignSelf: "center",
      marginTop: "10px",
      backgroundColor: "#000",
      color: "#FFF",
      justifyContent: "center",
      itemsCenter: "center",
      borderRadius: "24px",
    },
    cancelBtn: {
      display: "flex",
      width: "150px",
      height: "45px",
      alignSelf: "center",
      marginTop: "10px",
      color: "#000",
      justifyContent: "center",
      itemsCenter: "center",
      borderRadius: "24px",
    },
    confirmText: {
      flex: 1,
      justifyContent: "center",
      textAlign: "center",
      marginTop: "15px",
      font: theme.custom.font.headingMontserrat3,
    },
    titleDialog: {
      font: theme.custom.font.montserrat14,
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "12px",
    },
    iconClose: {
      cursor: "pointer",
    },
    contentDialog: {
      font: theme.custom.font.montserrat14,
      fontSize: "15px",
      lineHeight: "24px",
    },
    buttonContainer: {
      height: 100,
      marginRight: 20,
    },
  };
});

export default useStyles;
